import { render, staticRenderFns } from "./checkoutdone.vue?vue&type=template&id=0535aaea&scoped=true"
import script from "./checkoutdone.vue?vue&type=script&lang=js"
export * from "./checkoutdone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535aaea",
  null
  
)

export default component.exports